import quizactivity1 from "../../../assets/CampuLifeImages/quizactivity1.jpg"
import quizactivity2 from "../../../assets/CampuLifeImages/quizactivity2.jpg"
import quizactivity3 from "../../../assets/CampuLifeImages/quizactivity3.jpg"
import quizactivity4 from "../../../assets/CampuLifeImages/quizactivity4.jpg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage'
import quizbanner from "../../../assets/CampuLifeImages/quizbanner.jpg"

const QuizClub = () => {
   
   const data = 
    { 
      name:"quiz",
          viewmore:"true",
      viewless:"true",
      hover:true,
      pagename: "Quiz Club", 
      title: "Quiz Club Activities",
      contentImg:quizbanner,
      para:"The Quiz Club aims to foster a culture of curiosity, learning, and intellectual engagement among students. It provides a platform for quizzing enthusiasts to enhance their knowledge across fields such as general knowledge, current affairs, science, history, literature, and more. The club encourages teamwork, critical thinking, and quick decision-making through quizzes, and interactive sessions.",
      paraobjective:"Objectives",
      paratitlecontents:[
        {content:"To create a group of young minds with quizzing talent."},
        {content:"To provide information about the present scenario of quizzing."},
        {content:"To identify students who have a flair for quizzing."},
        {content:"To encourage the students to participate in regional, state and national quiz competitions conducted by various higher learning Institutions."},
        {content:"To expose the quizzing talents of students by involving them to conduct intercollegiate and interdepartmental quiz competitions."},
        {content:"To promote a healthy debate amongst participants in order to learn from each other."},
      ],
      fourhover:true
    }
   
   const hoverContent =[
     {  img: quizactivity1, para1: "Qiuz Club Inauguration", para2: "January 25, 2024" },
     {  img: quizactivity2, para1: "Qiuz Competition", para2: "September 2, 2024" },
     {  img: quizactivity3, para1: "Honour Winners on College Day", para2: "" },
     {  img: quizactivity4, para1: "Qiuz Competition", para2: "" }
 ]

 const tableData = [
  {title:"Quiz Club Organizers"},
  {headings:[{heading1:"S.No",heading2:"Name",heading4:"Position"}]},
  {data:[{ id: 1, name: 'Dr. D. GnanslinSheeba' ,pos:"Member"},
  { id: 2, name: 'Mrs. V. R. Lakshmi Rekha', pos:"Member" },
 
]},
  {padding:true}
];
  return (
    <>
    <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
    
    </>
  )
}

export default QuizClub